import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FontsService {
  public defaultSize = 16;
  private _currentFontSize = 0;
  private _maxFontSize = 36;
  private _minFontSize = 16;
  // private _changeFactorValue = .2;


  private _changeFactorValue = 4;

  public headerBaseFontSize = 20;
  public headerCurrentFontSize = 0;
  public headerMaxFontSize = 28;

  public spanPinkBaseFontSize = 28;
  public spanPinkCurrentFontSize = 0;
  public spanPinkMaxFontSize = 36;

  public header3BaseFontSize = 16;
  public header3CurrentFontSize = 0;
  public header3MaxFontSize = 24;

  public header4BaseFontSize = 18;
  public header4CurrentFontSize = 0;
  public header4MaxFontSize = 26;

  public header5BaseFontSize = 14;
  public header5CurrentFontSize = 0;
  public header5MaxFontSize = 22;

  public topicHeaderBaseFontSize = 34;
  public topicHeaderCurrentFontSize = 0;
  public topicHeaderMaxFontSize = 42;

  public titleBaseFontSize = 24;
  public titleCurrentFontSize = 0;
  public titleMaxFontSize = 32;

  constructor() {
    this._currentFontSize = this.defaultSize;
    this.headerCurrentFontSize = this.headerBaseFontSize;
    this.spanPinkCurrentFontSize = this.spanPinkBaseFontSize;
    this.header3CurrentFontSize = this.header3BaseFontSize;
    this.header4CurrentFontSize = this.header4BaseFontSize;
    this.header5CurrentFontSize = this.header5BaseFontSize;
    this.topicHeaderCurrentFontSize = this.topicHeaderBaseFontSize;
    this.titleCurrentFontSize = this.titleBaseFontSize;
   }

   public increaseSize() {
    // if (this._currentFontSize <= this._maxFontSize) {
    //     this._currentFontSize = this._currentFontSize + (this._currentFontSize * this._changeFactorValue);
    // }

    // return this._currentFontSize;
    const callerType = 'increase';
    this.setHeaderStyleObject(callerType);
    this.setSpanPinkStyleObject(callerType);
    this.setHeader3StyleObject(callerType);
    this.setHeader4StyleObject(callerType);
    this.setHeader5StyleObject(callerType);
    this.setTopicHeaderStyleObject(callerType);
    this.setTitleStyleObject(callerType);
  }

  public decreaseSize() {
      // if (this._currentFontSize >= this._minFontSize) {
      //     this._currentFontSize = this._currentFontSize - (this._currentFontSize * this._changeFactorValue);
      // } else {
      //     // this._currentFontSize = this._minFontSize;
      // }

      // return this._currentFontSize;
    const callerType = 'decrease';
    this.setHeaderStyleObject(callerType);
    this.setSpanPinkStyleObject(callerType);
    this.setHeader3StyleObject(callerType);
    this.setHeader4StyleObject(callerType);
    this.setHeader5StyleObject(callerType);
    this.setTopicHeaderStyleObject(callerType);
    this.setTitleStyleObject(callerType);
  }

  public setHeaderStyleObject(callType: string): any {

    if (callType === 'increase') {
      if (this.headerCurrentFontSize < this.headerMaxFontSize) {
        // this.headerCurrentFontSize = this.headerCurrentFontSize + (this.headerCurrentFontSize * this._changeFactorValue);
        this.headerCurrentFontSize = this.headerCurrentFontSize + this._changeFactorValue;
      }
    } else if (callType === 'decrease') {
      if (this.headerCurrentFontSize > this.headerBaseFontSize) {
        // this.headerCurrentFontSize = this.headerCurrentFontSize - (this.headerCurrentFontSize * this._changeFactorValue);
        this.headerCurrentFontSize = this.headerCurrentFontSize - this._changeFactorValue;
      }
    }

  }

  public getHeaderStyleObject(): any {
    return {
      'font-size': (this.headerCurrentFontSize) +  'px'
    };
  }

  public setSpanPinkStyleObject(callType: string): any {

    if (callType === 'increase') {
      if (this.spanPinkCurrentFontSize < this.spanPinkMaxFontSize) {
        this.spanPinkCurrentFontSize = this.spanPinkCurrentFontSize + this._changeFactorValue;
      }
    } else if (callType === 'decrease') {
      if (this.spanPinkCurrentFontSize > this.spanPinkBaseFontSize) {
        this.spanPinkCurrentFontSize = this.spanPinkCurrentFontSize - this._changeFactorValue;
      }
    }

  }

  public getSpanPinkStyleObject(): any {
    return {
      'font-size': (this.spanPinkCurrentFontSize) +  'px'
    };
  }

  public setHeader3StyleObject(callType: string): any {

    if (callType === 'increase') {
      if (this.header3CurrentFontSize < this.header3MaxFontSize) {
        // this.headerCurrentFontSize = this.headerCurrentFontSize + (this.headerCurrentFontSize * this._changeFactorValue);
        this.header3CurrentFontSize = this.header3CurrentFontSize + this._changeFactorValue;
      }
    } else if (callType === 'decrease') {
      if (this.header3CurrentFontSize > this.header3BaseFontSize) {
        // this.headerCurrentFontSize = this.headerCurrentFontSize - (this.headerCurrentFontSize * this._changeFactorValue);
        this.header3CurrentFontSize = this.header3CurrentFontSize - this._changeFactorValue;
      }
    }

  }

  public getHeader3StyleObject(): any {
    return {
      'font-size': (this.header3CurrentFontSize) +  'px'
    };
  }

  public setHeader4StyleObject(callType: string): any {

    if (callType === 'increase') {
      if (this.header4CurrentFontSize < this.header4MaxFontSize) {
        // this.headerCurrentFontSize = this.headerCurrentFontSize + (this.headerCurrentFontSize * this._changeFactorValue);
        this.header4CurrentFontSize = this.header4CurrentFontSize + this._changeFactorValue;
      }
    } else if (callType === 'decrease') {
      if (this.header4CurrentFontSize > this.header4BaseFontSize) {
        // this.headerCurrentFontSize = this.headerCurrentFontSize - (this.headerCurrentFontSize * this._changeFactorValue);
        this.header4CurrentFontSize = this.header4CurrentFontSize - this._changeFactorValue;
      }
    }

  }

  public getHeader4StyleObject(): any {
    return {
      'font-size': (this.header4CurrentFontSize) +  'px'
    };
  }

  public setHeader5StyleObject(callType: string): any {

    if (callType === 'increase') {
      if (this.header5CurrentFontSize < this.header5MaxFontSize) {
        // this.headerCurrentFontSize = this.headerCurrentFontSize + (this.headerCurrentFontSize * this._changeFactorValue);
        this.header5CurrentFontSize = this.header5CurrentFontSize + this._changeFactorValue;
      }
    } else if (callType === 'decrease') {
      if (this.header5CurrentFontSize > this.header5BaseFontSize) {
        // this.headerCurrentFontSize = this.headerCurrentFontSize - (this.headerCurrentFontSize * this._changeFactorValue);
        this.header5CurrentFontSize = this.header5CurrentFontSize - this._changeFactorValue;
      }
    }

  }

  public getHeader5StyleObject(): any {
    return {
      'font-size': (this.header5CurrentFontSize) +  'px'
    };
  }

  public setTopicHeaderStyleObject(callType: string): any {

    if (callType === 'increase') {
      if (this.topicHeaderCurrentFontSize < this.topicHeaderMaxFontSize) {
        // this.headerCurrentFontSize = this.headerCurrentFontSize + (this.headerCurrentFontSize * this._changeFactorValue);
        this.topicHeaderCurrentFontSize = this.topicHeaderCurrentFontSize + this._changeFactorValue;
      }
    } else if (callType === 'decrease') {
      if (this.topicHeaderCurrentFontSize > this.topicHeaderBaseFontSize) {
        // this.headerCurrentFontSize = this.headerCurrentFontSize - (this.headerCurrentFontSize * this._changeFactorValue);
        this.topicHeaderCurrentFontSize = this.topicHeaderCurrentFontSize - this._changeFactorValue;
      }
    }

  }

  public getTopicHeaderStyleObject(): any {
    return {
      'font-size': (this.topicHeaderCurrentFontSize) +  'px'
    };
  }

  public setTitleStyleObject(callType: string): any {

    if (callType === 'increase') {
      if (this.titleCurrentFontSize < this.titleMaxFontSize) {
        // this.headerCurrentFontSize = this.headerCurrentFontSize + (this.headerCurrentFontSize * this._changeFactorValue);
        this.titleCurrentFontSize = this.titleCurrentFontSize + this._changeFactorValue;
      }
    } else if (callType === 'decrease') {
      if (this.titleCurrentFontSize > this.titleBaseFontSize) {
        // this.headerCurrentFontSize = this.headerCurrentFontSize - (this.headerCurrentFontSize * this._changeFactorValue);
        this.titleCurrentFontSize = this.titleCurrentFontSize - this._changeFactorValue;
      }
    }

  }

  public getTitleStyleObject(): any {
    return {
      'font-size': (this.titleCurrentFontSize) +  'px'
    };
  }
}
